function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 27a.786.786 0 01-.566-.242L13.22 20.35c-1.628-1.68-1.628-4.413 0-6.093A4.09 4.09 0 0116.177 13a4.09 4.09 0 012.955 1.258l.868.895.867-.895A4.09 4.09 0 0123.823 13a4.09 4.09 0 012.956 1.258c1.628 1.68 1.628 4.413 0 6.093l-6.213 6.408A.788.788 0 0120 27z",
  fill: "#FA4504"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref);
}

export default SvgHeart;